(ns ncr.manage.folders
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.widgets.domain :as wdom]
   [ncr.backend :as b]
   [ncr.amplitude :as amp]
   [ncr.etc.alert :as a]
   [ncr.etc.modal :as m]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.rhf :as rhf]
   [ncr.widgets.pf :as wpf]
   [ncr.me :as me]
   [ncr.navigate :as n]))

(defn- c-folder-dialog [{:keys [mode model]}]
  (let
    [{:keys [register-pf] :as form}
     (rhf/use-form {:shouldFocusError false :default-values model})

     modal-id :new-folder-modal
     ref (uix/ref)
     submit (rhf/modal-submit form)]

    (m/use-submit-form modal-id ref submit)

    [m/c-modal
     {:title (get {:update "Update Folder" :new "New Folder"} mode)
      :variant :small
      :is-overflow-visible true
      :id modal-id
      :ref ref
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click submit}
        "Save"]

       [pf/c-button
        {:variant :link
         :on-click #(m/close! nil)}
        "Cancel"]]}
     [pf/c-form {}
      (let [id (uix/memo #(gensym) [])]
        [rhf/c-form-group {:label "Name" :is-required true :field-id id} :name form
         [pf/c-text-input
          (merge (register-pf :name {:required true}) {:id id})]])

      (let [id (uix/memo #(gensym) [])]
        [rhf/c-form-group {:label "Access" :field-id id} :name form
         [wdom/c-users-selector {:name :access :form form :specials [] :id id}]])]]))

(defn- folder-op [operation mutation]
  (a/!operation operation
    (go
      (u/error-m [_ (<! (b/!mutation mutation))]
        (ps/pub! [:me/load])
        (ps/pub! [::load])))))

(defn- !new-folder []
  (go
    (when-let
      [folder
       (<!
         (m/!modal #'c-folder-dialog
           {:mode :new
            :model {:name "" :access #{}}}))]
      (folder-op
        {:operation-title "Adding Folder"
         :success-title "Folder Added"
         :body (:name folder)}
        [:folder_create folder [:id]]))))

(defn- !update-folder [folder]
  (go
    (when-let
      [folder
       (<!
         (m/!modal #'c-folder-dialog
           {:mode :new
            :model folder}))]
      (folder-op
        {:operation-title "Updating Folder"
         :success-title "Folder Updated"
         :body (:name folder)}
        [:folder_update (select-keys folder [:id :name :access]) [:id]]))))

(defn- !delete-folder [{nm :name :keys [id]}]
  (go
    (when
      (<!
        (m/!alert
          {:title "Deleting Folder"
           :title-icon-variant :warning
           :actions-variant :ok-cancel
           :body
           [:span
            "Are you sure you want to delete folder "
            [:b (pr-str nm)]
            "?"]}))
      (folder-op
        {:operation-title "Deleting Folder"
         :success-title "Folder Deleted"
         :body nm}
        [:folder_delete {:id id}]))))

(defn use-folders []
  (let
    [state
     (ps/sub-reducer-map! {:status nil}
       {::set (fn [old state] state)

        ::load
        (fn [state]
          (go
            (u/if-ok
              [rv
               (<! (b/!query
                     [:folders [:id :name :folderType :access :fragmentCount]]))]
              (ps/pub!
                [::set {:status :loaded :items rv}])
              (ps/pub! [::set {:status :error :error rv}])))
          {:status :loading
           :items (:items state)})})]
    (uix/with-effect []
      (ps/pub! [::load true]))
    state))

(defn- c-toolbar []
  [pf/c-toolbar
   [pf/c-toolbar-content
    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :arrow-left
       :on-click
       (fn [_]
         (amp/navigate! {"Origin" "Manage Folders" "Destination" "<back>"})
         (n/back!))
       :tooltip "Back"}]

     [w/c-toolbar-button
      {:icon :reload
       :on-click #(ps/pub! [::load])
       :tooltip "Reload"}]]

    [pf/c-toolbar-group {:variant :icon-button-group}
     [w/c-toolbar-button
      {:icon :plus
       :on-click !new-folder
       :tooltip "Add"}]]]])

(defn- c-folder [{:keys [users]} {:keys [access id fragmentCount] folder-name :name :as label}]
  [pf/c-data-list-item
   {:class :pf-m-selectable
    :on-click #(!update-folder label)}
   [pf/c-data-list-item-row
    [pf/c-data-list-item-cells {}
     [pf/c-data-list-cell {:width 1}
      [pf/l-flex {:direction :column :space-items :space-items-xs}
       [:span folder-name]
       [:span.pf-u-color-200
        (when fragmentCount
          (str "Fragments: " (str fragmentCount)))]]]

     [pf/c-data-list-cell {:width 3}
      [wpf/c-label-group
       (let
         [access
          (->> access
            (map
              #(when-let [label (get-in users [% :name])]
                 [% label]))
            (filter some?)
            (sort-by second))]
         (for [[id label-text] access]
           [pf/c-label
            (w/merge-props
              {:class [:pf-u-font-size-sm]
               :key id
               :variant :outline})
            label-text]))]]]

    [pf/c-data-list-action {}
     [pf/c-dropdown-menu
      {:dropdown-items
       [[pf/c-dropdown-item
         {:icon [w/c-menu-icon {:icon :pencil-outline}]
          :on-click #(!update-folder label)}
         "Edit"]
        [pf/c-dropdown-item
         {:icon [w/c-menu-icon {:icon :minus}]
          :on-click #(!delete-folder label)
          :is-disabled (> fragmentCount 0)}
         "Delete"]]}]]]])

(defn c-manage-folders []
  (let
    [state (use-folders)

     users
     (u/index-by :id (get-in (uix/context me/*context*) [:cluster :users]))]

    [:<>
     [pf/c-page-section {:class :pf-u-p-0 :aria-label "Toolbar"}
      [c-toolbar]]

     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :light
       :has-overflow-scroll true
       :aria-label "Folder list"}
      (let [{folders :items reason :error} @state]
        (cond
          reason
          [pf/c-alert
           {:class :pf-u-w-100
            :is-inline true
            :variant :danger
            :title (str "Error: " reason)}]

          (sequential? folders)
          [pf/c-data-list {:is-compact true}
           (for
             [{:keys [id] :as folder}
              (sort-by :name folders)]
             ^{:key id} [c-folder {:users users} folder])]

          :else
          [w/c-empty-progress {:class :pf-u-w-100} "Loading..."]))]]))
